import {select, fork, take, put} from 'redux-saga/effects';
import {persistenceStates} from '@computerrock/formation-core';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as invoiceActionTypes from '../invoiceActionTypes';
import * as taskActionTypes from '../../tasks/taskActionTypes';

const searchInvoices = function* searchInvoices({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const leaAssignmentFlowService = serviceManager.loadService('leaAssignmentFlowService');
    const {searchQueryParams} = payload;

    yield put({
        type: invoiceActionTypes.STORE_INVOICES_SEARCH_RESULTS,
        payload: {
            invoiceDTOs: [],
            totalCount: 0,
            persistenceState: persistenceStates.PENDING,
            isError: false,
        },
    });

    yield fork(fetchRequest,
        invoiceActionTypes.SEARCH_INVOICES_REQUEST,
        leaAssignmentFlowService.getInvoices, {
            searchQueryParams,
        });

    const searchInvoicesResponseAction = yield take([
        invoiceActionTypes.SEARCH_INVOICES_REQUEST_SUCCEEDED,
        invoiceActionTypes.SEARCH_INVOICES_REQUEST_FAILED,
    ]);

    if (!searchInvoicesResponseAction.error) {
        const {response} = searchInvoicesResponseAction.payload;
        const {invoiceDTOs, totalCount} = response;

        yield put({
            type: invoiceActionTypes.STORE_INVOICES_SEARCH_RESULTS,
            payload: {
                invoiceDTOs,
                totalCount,
                persistenceState: persistenceStates.READY,
                isError: false,
            },
        });
    }

    if (searchInvoicesResponseAction.error) {
        yield put({
            type: invoiceActionTypes.STORE_INVOICES_SEARCH_RESULTS,
            payload: {
                invoiceDTOs: [],
                totalCount: 0,
                persistenceState: persistenceStates.READY,
                isError: true,
            },
        });
    }

    // reset tasks results - fix for ACEDEV-809
    yield put({
        type: taskActionTypes.STORE_TASK_SEARCH_RESULTS,
        payload: {
            taskDTOs: [],
            taskSearchResultsCount: 0,
        },
    });
    yield put({type: taskActionTypes.RESET_TASK_COUNT_INDICATOR});

    window.sessionStorage.setItem('serviceCaseOriginQueryParams', searchQueryParams.toString());
};

export default searchInvoices;
